/**
 *
 * Asynchronously loads the component for AdvisorGoals
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorGoals = lazyLoad(
  () => import('./index'),
  module => module.AdvisorGoals,
);
